module.exports = __webpack_public_path__ + "img/11179_DENIMAX.00b260db.webp";